// page-components/blogs/ClientProgressBar.tsx
'use client'
import React, { useState, useEffect } from 'react'
import ProgressBar from './ProgressBar'

const ClientProgressBar = () => {
  const [progress, setProgress] = useState(0)
  
  useEffect(() => {
    const handleScroll = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight
      const scrolled = (winScroll / height) * 100
      
      // Round to 1 decimal place to avoid long floating point numbers
      setProgress(Math.round(scrolled * 10) / 10)
    }
    
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  
  return <ProgressBar percentage={progress} />
}

export default ClientProgressBar